import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ProductModel} from './shared/classes/product-model.model';
import {Category} from './shared/classes/category.model';
import {NavigationBarService} from './shared/navigation-bar.service';

@Component({
  selector: 'app-main-section',
  templateUrl: './main-section.component.html',
  styleUrls: ['./main-section.component.css']
})
export class MainSectionComponent implements OnInit {
  @Output() getSelectedCategory: EventEmitter<Category> = new EventEmitter<Category>();
  tabSelected = 0;
  mainForm: FormGroup;
  selectedModel: ProductModel;
  public showComponent: Boolean = true;

  constructor(private navBarService: NavigationBarService) {
    this.navBarService.selectedTabChange.subscribe(val => {
      this.tabSelected = this.navBarService.getSelectedTab();
    });
  }

  ngOnInit() {
    if(window.location.pathname == '/status') {
      this.showComponent = false;
    }
  }

  changeCategory(category: Category) {
    this.getSelectedCategory.emit(category);
  }
}





// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/main-section.component.ts